import _ from 'lodash'
import { useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';

export default function VehicleCard({ isButtonLoading, vehicleData, productTypeCargo, handleEstimate, selectedEstimateItem, handleInnerFormChange }: any) {

    const [vehicle, setVehicle] = useState<any>();
    const dummyImage = require('../../../../../assets/img/image.png')
    const onEstimateClick = () => {
        handleEstimate(vehicle)
    }
    const vehicleType = [
        {
            Id: 1,
            Name: "below 500kg"
        },
        {
            Id: 2,
            Name: "below 700kg"
        },
        {
            Id: 3,
            Name: "below 1000kg"
        }
    ]
    return (
        <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-2xl shadow-lg">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">Order Details</h2>

            <div className="space-y-6">
                {/* Company */}
                <div className="grid sm:grid-cols-3 gap-4 items-center">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700">
                        Company :
                    </label>
                    <input
                        id="company"
                        type="text"
                        placeholder="Enter company name"
                        value={selectedEstimateItem?.ProductValue}
                        onChange={(e) => handleInnerFormChange(e.target.value, 'ProductValue')}
                        className="sm:col-span-2 w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                {/* Product Type */}
                <div className="grid sm:grid-cols-3 gap-4 items-center">
                    <label htmlFor="productType" className="block text-sm font-medium text-gray-700">
                        Product Type :
                    </label>
                    <select
                        id="productType"
                        required
                        value={selectedEstimateItem?.CategoryId || ""}
                        onChange={(e) => handleInnerFormChange(e.target.value, 'CategoryId')}
                        className="sm:col-span-2 w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="">-- Select --</option>
                        {productTypeCargo?.map((item) => (
                            <option key={item.Id} value={item.Id}>{item.Name}</option>
                        ))}
                    </select>
                </div>

                {/* Schedule Date */}
                <div className="grid sm:grid-cols-3 gap-4 items-center">
                    <label htmlFor="scheduleDate" className="block text-sm font-medium text-gray-700">
                        Schedule Date/Time :
                    </label>
                    <input
                        id="scheduleDate"
                        type="date"
                        value={selectedEstimateItem?.ProductValue}
                        onChange={(e) => handleInnerFormChange(e.target.value, 'ProductValue')}
                        className="sm:col-span-2 w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                {/* Vehicle Type */}
                <div className="grid sm:grid-cols-3 gap-4 items-center">
                    <label htmlFor="vehicleType" className="block text-sm font-medium text-gray-700">
                        Vehicle Type :
                    </label>
                    <select
                        id="vehicleType"
                        required
                        value={selectedEstimateItem?.CategoryId || ""}
                        onChange={(e) => handleInnerFormChange(e.target.value, 'CategoryId')}
                        className="sm:col-span-2 w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="">-- Select --</option>
                        {vehicleType?.map((item) => (
                            <option key={item.Id} value={item.Id}>{item.Name}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Vehicle Selection */}
            <div className="mt-8">
                <label className="block text-sm font-medium text-gray-700">Choose Vehicle :</label>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
                    {vehicleData?.map((item, index) => (
                        <button
                            key={index}
                            onClick={() => setVehicle(item)}
                            className={`w-full flex flex-col items-center p-3 rounded-md border transition ${vehicle === item
                                ? 'border-blue-500 text-blue-600 bg-blue-50'
                                : 'border-gray-200 hover:border-blue-300'
                                }`}
                        >
                            <div className="w-20 h-20 mb-2 flex items-center justify-center">
                                <img
                                    src={item?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL || dummyImage}
                                    alt={item.VehicleType || 'Vehicle'}
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <span className="text-sm font-medium">{item?.VehicleType}</span>
                        </button>
                    ))}
                </div>
            </div>

            {/* Recurring Option */}
            <div className="mt-6 flex items-center space-x-2 pb-2">
                <input
                    type="checkbox"
                    id="isRecurring"
                    onChange={(e) => handleInnerFormChange(e.target.checked, 'isRecurring')}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label htmlFor="isRecurring" className="block text-sm font-medium text-gray-700 mb-1">
                    Repeat This Order (Optional)
                </label>
            </div>

            {/* Recurrence Settings */}
            {selectedEstimateItem?.isRecurring && (
                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <label htmlFor="recurrenceFrequency" className="block text-sm font-medium text-gray-700 mb-1">
                            Frequency
                        </label>
                        <select
                            id="recurrenceFrequency"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Select Frequency</option>
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="recurrenceEnd" className="block text-sm font-medium text-gray-700 mb-1">
                            End Date (Optional)
                        </label>
                        <input
                            type="date"
                            id="recurrenceEnd"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                </div>
            )}

            {/* Submit Button */}
            <div className="mt-10 flex justify-center ">
                <button
                    onClick={onEstimateClick}
                    disabled={isButtonLoading}
                    className={`w-1/2 flex items-center justify-center px-6 py-2 rounded-md text-white font-semibold text-sm transition ${isButtonLoading
                        ? 'bg-blue-500 bg-opacity-70 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700'
                        }`}
                >
                    Estimate
                    {isButtonLoading && (
                        <div className="pl-2">
                            <RotatingLines
                                visible={true}
                                width="16"
                                strokeColor="#fff"
                                strokeWidth="5"
                                animationDuration="0.75"
                                ariaLabel="Loading..."
                            />
                        </div>
                    )}
                </button>
            </div>
        </div>



    );
}
